const SET_MOBILE = "styles:SET_MOBILE";

export {SET_MOBILE};
